module.exports = __webpack_public_path__ + "assets/img/logo.d1259dc8.svg";